import React, { useState } from 'react';
import HeroModern from './HeroModern';
import HeroBold from './HeroBold';
import HeroSophisticated from './HeroSophisticated';

const HeroDemo = () => {
  const [activeDemo, setActiveDemo] = useState('modern');

  return (
    <div className="relative">
      {/* Style Selector - Fixed at top */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-gray-900 border-b border-gray-700 shadow-xl">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-wrap gap-4 items-center justify-between">
            <h2 className="text-white font-bold text-lg">Choose Your Style:</h2>
            <div className="flex gap-3">
              <button
                onClick={() => setActiveDemo('modern')}
                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                  activeDemo === 'modern'
                    ? 'bg-green-600 text-white'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                Modern & Minimal
              </button>
              <button
                onClick={() => setActiveDemo('bold')}
                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                  activeDemo === 'bold'
                    ? 'bg-yellow-500 text-orange-900'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                Bold & Vibrant
              </button>
              <button
                onClick={() => setActiveDemo('sophisticated')}
                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                  activeDemo === 'sophisticated'
                    ? 'bg-amber-600 text-white'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                Sophisticated
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Demo Content */}
      <div className="pt-20">
        {activeDemo === 'modern' && <HeroModern />}
        {activeDemo === 'bold' && <HeroBold />}
        {activeDemo === 'sophisticated' && <HeroSophisticated />}
      </div>

      {/* Info Panel */}
      <div className="fixed bottom-6 right-6 bg-white rounded-lg shadow-2xl p-6 max-w-sm z-50 border-2 border-gray-200">
        <h3 className="font-bold text-gray-900 mb-2 text-lg">
          {activeDemo === 'modern' && '✨ Modern & Minimal'}
          {activeDemo === 'bold' && '🔥 Bold & Vibrant'}
          {activeDemo === 'sophisticated' && '💎 Sophisticated'}
        </h3>
        <p className="text-gray-600 text-sm mb-3">
          {activeDemo === 'modern' && 'Clean design with animated gradients. Professional and trustworthy.'}
          {activeDemo === 'bold' && 'Eye-catching with image slideshow. Vibrant and energetic.'}
          {activeDemo === 'sophisticated' && 'Elegant with product cards. Refined and premium.'}
        </p>
        <div className="text-xs text-gray-500 border-t pt-3">
          <p>✅ NPOP Certification highlighted</p>
          <p>✅ Specific products mentioned</p>
          <p>✅ Mobile responsive design</p>
        </div>
      </div>
    </div>
  );
};

export default HeroDemo;
